export * from '@core/js/utils/math.util';

/* TotalCasino changes */
/**
 * Find modulo of an integer number of any length
 * @param {String} divident - a string, containing an integer of any length
 * @param {Number} divisor - an integer number < Number.MAX_SAFE_INTEGER
 * @returns {number}
 */
export const modulo = (divident, divisor) => {
    let remainder = 0;

    for (let i = 0; i < divident.length; i++) {
        remainder = (remainder * 10 + Number(divident[i])) % divisor;
    }

    return remainder;
};
/* TotalCasino changes */
